export default "__VITE_ASSET__Bn0KSw79__"